import { testIsNonEmptyString } from '../../lib/test-and-assert/test-base';

/**
 * @param {String|any} maybeCurrency
 *
 * @return {Boolean}
 */
function testIsCurrency(maybeCurrency) {
    if (!testIsNonEmptyString(maybeCurrency)) {
        return false;
    }

    const validCurrencies = ['usd', 'eur', 'inr'];
    return validCurrencies.includes(maybeCurrency);
}

export { testIsCurrency };
